export default "__VITE_ASSET__CJjbtX3K__"